import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';
import {AssetServer} from "@/api";

export const DICTIONARY_FACTORY_ASSET_ATTRIBUTE = 'AssetAttribute';
export const DICTIONARY_FACTORY_ASSET_ATTRIBUTE_TYPE_ALL = 'ALL';
export default class AssetAttributeDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ASSET_ATTRIBUTE});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ASSET_ATTRIBUTE_TYPE_ALL: {
                let assetAttributes = [];
                let response = await AssetServer.assetAttribute.all({});
                if (response.data.code === 200) {
                    assetAttributes = response.data.data;
                }
                for (let i = 0, len = assetAttributes.length; i < len; i++) {
                    assetAttributes[i]._text = assetAttributes[i].assetattrid + '-' + assetAttributes[i].description;
                }
                dictionary = new Dictionary({items: assetAttributes, valueKey: 'assetattributeid', textKey: '_text'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}
